import { SERVER } from "../constants";
import { stringify } from "query-string";
import { MAP_URL } from "../constants/urls";
import { HttpClient } from "../utils/requests";
import { fixGetManyAdminUser } from "../panels/adminUsers/adminUsersMapper";
import { fixGetManyInsertPaybills } from "../panels/hr/insertPaybill/insertPaybillMapper";
import { fixGetManyPaybillss } from "../panels/hr/paybills/paybillsMapper";
import { fixGetManyRequests } from "../panels/hr/requests/requestsMapper";

export function getMany(resource, params) {

  const query = {
    filter: JSON.stringify({ id: params.objectId }),
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;
  return HttpClient(url).then(({ headers, json }) => {
    if (resource === 'adminUsers') {
      return fixGetManyAdminUser(headers, json);
    } else if (resource === 'insertPaybill') {
      return fixGetManyInsertPaybills(headers, json);
    } else if (resource === 'paybills') {
      return fixGetManyPaybillss(headers, json);
    } else if (resource === 'request') {
      return fixGetManyRequests(headers, json);
    }
    return {
      data: { ...json, id: json.objectId },
    };
  }

  );
}